import { render, staticRenderFns } from "./TemporaryRightDrawer.vue?vue&type=template&id=20138fa9"
import script from "./TemporaryRightDrawer.vue?vue&type=script&lang=js"
export * from "./TemporaryRightDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemporaryRightDrawer.vue?vue&type=style&index=0&id=20138fa9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports